import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    USER_DETAIL,
} from '../actions';

import {
    UserDetailSuccess,
    UserDetailError
} from '../actions';

export function* watchUserDetail() {
    yield takeEvery(USER_DETAIL, onUserDetail);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onUserDetailAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'user/detail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

function* onUserDetail(data) {
    try {
        const response = yield call(onUserDetailAsync, data.payload);
        yield put(UserDetailSuccess(response.data));
    } catch (error) {
        yield put(UserDetailError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchUserDetail)
    ]);
}
